<template>
	<div>
		<div class="conmtont">
			<div class="flex align-center justify-between padding-sm bg-white margin-tb">
				<el-breadcrumb separator-class="el-icon-minus">
				  <el-breadcrumb-item :to="{ path: '/' }"><span class="text-sm">首页</span></el-breadcrumb-item>
				  <el-breadcrumb-item><span class="text-sm">招标信息</span></el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div class="bg-white padding-sm margin-bottom-sm">
				<div class="flex margin-bottom-sm">
					<p class="titla text-left text-xs text-666">全部分类：</p>
					<p>
						<span class="margin-right-sm text-xs pointer pro-item" @click="choseprofession(item)" :class="categroyId == item.id?'text-theme':'text-666'" v-for="(item,index) in profession" :key="index">{{item.name}}</span>
					</p>
				</div>
				<div class="flex margin-bottom-sm">
					<p class="titla text-left text-xs text-666">信息类型：</p>
					<p>
						<span class="margin-right-sm text-xs pointer pro-item" @click="chosetype(index)" :class="typeindex == index?'text-theme':'text-666'" v-for="(item,index) in city" :key="index">{{item.name}}</span>
					</p>
				</div>
				<div class="flex">
					<p class="titla text-left text-xs text-666">排序方式：</p>
					<p>
						<span class="margin-right-sm text-xs pointer pro-item" @click="chose(index)" :class="sortindex == index?'text-theme':'text-666'" v-for="(item,index) in sort" :key="index">{{item.name}}</span>
					</p>
				</div>
			</div>
			<div class="flex">
				<div class="flex-sub">
					<div v-if="total != 0">
						<div v-for="(item,indx) in lists" :key="indx">
							<BidList :data="item" :width="786" :height="184" :size="24"></BidList>
						</div>
						<div class="pagination">
							<el-pagination
							@current-change="handleCurrentChange"
							  background
							  layout="prev, pager, next"
							  prev-text="上一页"
							  next-text="下一页"
							  :total="total">
							</el-pagination>
						</div>
					</div>
					<div class="text-center" v-else>
						<el-empty description="暂无数据"></el-empty>
					</div>
				</div>
				<div class="margin-left" v-if="newlist.length != 0">
					<div class="flex align-center justify-between margin-bottom-sm">
						<p class="title padding-left-sm">最新招标</p>
					</div>
					<div v-for="(item,indx) in newlist" :key="indx">
						<BidList :data="item" :width="387" :height="168" :size="18"></BidList>
					</div>
				</div>
			</div>
		</div>
		<router-view />
	</div>
</template>

<script>
	import Top from '@/components/public/top.vue';
	import BidList from '@/components/list/bid-list.vue';
	import Bus from '@/store/eventBus.js'
	export default {
		components: {
			Top,
			BidList
		},
		name: '',
		data() {
			return {
				profession:[],//全部分类
				categroyId:0,//
				city:[
					{
						name:'全部',
						ischeck:true
					},{
						name:'招标公告',
						ischeck:false
					},{
						name:'中标结果',
						ischeck:false
					}
				],//信息类型
				typeindex:0,//信息类型 下表
				sort:[
					{
						name:'默认排序',
						ischeck:true
					},
					{
						name:'最新排序',
						ischeck:false
					}
				],//排序方式
				sortindex:0,//
				lists:[],//列表
				page:1,
				newlist:[],//最新列表
				page:1,
				total:0,//
			}
		},
		created() {
			//通知听不状态栏 选中的页面
			Bus.$emit('chosename','bidding')
			this.gettype()
			this.getlist()
			this.getnewlist()
		},
		methods: {
			back(){
				this.$router.back()
			},
			/**
			 * 获取招标分类
			 * */
			gettype(){
				this.ajax('get', '/api/pc/bidding/getBiddingCate', {}, res => {
					let arr = {
						id:0,
						name:'全部岗位',
						ischeck:true
					}
					res.data.map(item=>{
						item.ischeck = false
					})
					res.data.unshift(arr)
					this.profession= res.data
				})
			},
			handleCurrentChange: function(currentPage) {
			  this.page = currentPage;
			  this.getlist();
			},
			/**
			 * 获取租聘列表
			 **/
			getlist(){
				this.ajax('get', '/api/pc/bidding/getBidding', {
					page:this.page,
					limit:6,
					cate_id:this.categroyId == 0?'':this.categroyId,
					type:this.typeindex,
					is_sort:1
				}, res => {
					console.log('getlist',res);
					if(res.status == 200){
						this.lists = res.data.data
						console.log(this.lists);
						if(this.page == 1){
							this.total =  Number(res.data.lastpage) * Number(res.data.data.length)
						}
					}
				})
			},
			/**
			 * 获取最新租聘列表
			 **/
			getnewlist(){
				this.ajax('get', '/api/pc/bidding/getBidding', {
					page:this.page,
					limit:3,
					type:this.typeindex
				}, res => {
					console.log('getlist',res);
					if(res.status == 200){
						this.newlist = res.data.data
					}
				})
			},
			//分类筛选
			choseprofession(item){
				this.categroyId = item.id
				this.page = 1
				this.getlist()
			},
			chosetype(index){
				this.typeindex = index
				this.page = 1
				this.getlist()
			},
			/**
			 * 筛选
			 * */
			chose(index){
				this.sortindex = index
				this.page = 1
				this.getlist()
			},
		}
	}
</script>

<style scoped lang="less">
	.titla{
		width: 80px;
		word-spacing:25px;
	}
	.title{
		position: relative;
		font-size: 22px;
		&:before{
			position: absolute;
			left: 0;
			top: 50%;
			transform: translateY(-50%);
			width: 6px;
			height: 26px;
			background: #09827B;
			content: '';
			
		}
	}
	.pro-item:hover{
		color: #09827B;
	}
	/deep/ .el-pagination.is-background .btn-next,/deep/ .el-pagination.is-background .btn-prev,/deep/ .el-pagination.is-background .el-pager li{
		background: #fff !important;
	}
	/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
		background:#09827B !important;
		color: #fff !important;
	}
	/deep/ .el-pagination.is-background .btn-prev,/deep/ .el-pagination.is-background .btn-next{
		padding: 0 10px;
	}
	
	.pagination{
		margin: 59px 0;
	}
</style>



// WEBPACK FOOTER //
// src/view/index/bidding.vue